export default __webpack_public_path__ + "static/media/trash.4495d42c.svg";